import * as React from 'react';

import ErrorBoundary from '@components/ErrorBoundary';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { useNewPdDesignEnabled } from '../hooks/useNewPdDesignEnabled';

import { BazaarvoiceRatings } from './BazaarvoiceRatings';
import { IHeaderProps } from './model';
import { ProductRating } from './ProductRating';
import {
  StyledHeader,
  H1,
  Span,
  Description,
  SubName,
  BrandExtraLine,
  ProductNameWrapper,
} from './styled';
import { trackBrandClick, withSpaceAfterWord } from './utils';

export const Header = ({
  desc,
  collection,
  subName,
  brandInfo,
  catalogId,
  productCode,
  children,
  reviewsId,
  hideReviews = false,
}: React.PropsWithChildren<IHeaderProps>) => {
  const newPdDesign = useNewPdDesignEnabled();
  const { bazaarvoiceIntegrationPd } = useFeatureFlags();
  const { getTimeFromInit } = useTrackingContext();

  const handleTrackClick = () =>
    trackBrandClick({
      timing: getTimeFromInit(),
      name: brandInfo.name,
    });

  const showOwnRatings = !hideReviews && !bazaarvoiceIntegrationPd;
  const showBazaarvoiceRatings = !hideReviews && !!bazaarvoiceIntegrationPd;

  return (
    <ErrorBoundary>
      <StyledHeader id="pdHeader" newDesign={newPdDesign}>
        <H1 newDesign={newPdDesign}>
          <ProductNameWrapper newDesign={newPdDesign}>
            {brandInfo && (
              <BrandExtraLine
                onClick={handleTrackClick}
                href={brandInfo.url}
                newDesign={newPdDesign}
              >
                {brandInfo.name}
              </BrandExtraLine>
            )}

            <Span newDesign={newPdDesign}>
              {withSpaceAfterWord(collection)}
            </Span>
          </ProductNameWrapper>

          {subName && <SubName>{withSpaceAfterWord(subName)}</SubName>}

          <Description newDesign={newPdDesign}>{desc}</Description>
        </H1>

        {showOwnRatings && (
          <ProductRating reviewsId={reviewsId} catalogMasterId={catalogId} />
        )}

        {showBazaarvoiceRatings && (
          <BazaarvoiceRatings productCode={productCode} />
        )}

        {children}
      </StyledHeader>
    </ErrorBoundary>
  );
};
